"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodName = void 0;
var PaymentMethodName;
(function (PaymentMethodName) {
    PaymentMethodName["UNKNOWN"] = "UNKNOWN";
    PaymentMethodName["PENDING"] = "PENDING";
    PaymentMethodName["PROMO_CODE"] = "PROMO_CODE";
    PaymentMethodName["VOUCHER"] = "VOUCHER";
    PaymentMethodName["GIFT_CARD"] = "GIFT_CARD";
    PaymentMethodName["MEMBERSHIP"] = "MEMBERSHIP";
    PaymentMethodName["DISCOUNT"] = "DISCOUNT";
    PaymentMethodName["MEMBERSHIP_DISCOUNT"] = "MEMBERSHIP_DISCOUNT";
    PaymentMethodName["EXPERIENCEBANK"] = "EXPERIENCEBANK";
    PaymentMethodName["INVITATION"] = "invitation";
    PaymentMethodName["REFUNDED_VOUCHER"] = "REFUNDED_VOUCHER";
    PaymentMethodName["VISA"] = "VISA";
    PaymentMethodName["GOOGLEPAY"] = "GOOGLEPAY";
    PaymentMethodName["MASTERCARD"] = "MASTERCARD";
    PaymentMethodName["AMEX"] = "AMEX";
    PaymentMethodName["APPLEPAY"] = "APPLEPAY";
    PaymentMethodName["APPLEPAY_VISA"] = "APPLEPAY_VISA";
    PaymentMethodName["APPLEPAY_MASTERCARD"] = "APPLEPAY_MASTERCARD";
    PaymentMethodName["APPLEPAY_MAESTRO"] = "APPLEPAY_MAESTRO";
    PaymentMethodName["APPLEPAY_AMEX"] = "APPLEPAY_AMEX";
    PaymentMethodName["TWINT"] = "TWINT";
    PaymentMethodName["POST_CARD"] = "POSTCARD";
    PaymentMethodName["PAYPAL"] = "PAYPAL";
    PaymentMethodName["POSTFINANCE_EFINANCE"] = "POSTEFINANCE";
    PaymentMethodName["MAESTRO"] = "MAESTRO";
    PaymentMethodName["CHINA_UNION_PAY"] = "CHINA_UNION_PAY";
    PaymentMethodName["IDEAL"] = "IDEAL";
    PaymentMethodName["BANCONTACT"] = "BANCONTACT";
    PaymentMethodName["BANCONTACT_MOBILE"] = "BANCONTACT_MOBILE";
    PaymentMethodName["INVOICE"] = "INVOICE";
    PaymentMethodName["BANK_TRANSFER"] = "BANK_TRANSFER";
    PaymentMethodName["FREE"] = "FREE";
    PaymentMethodName["EXTERNAL_VOUCHER"] = "EXTERNAL_VOUCHER";
    PaymentMethodName["CASH"] = "CASH";
    PaymentMethodName["CHEQUE"] = "CHEQUE";
    PaymentMethodName["CHEQUE_CULTURE"] = "CHEQUE_CULTURE";
    PaymentMethodName["CHEQUE_VACANCES"] = "CHEQUE_VACANCES";
    PaymentMethodName["PASS_CULTURE"] = "PASS_CULTURE";
    PaymentMethodName["COUPON_SPORT"] = "COUPON_SPORT";
    PaymentMethodName["BON_DE_COMMANDE"] = "BON_DE_COMMANDE";
    PaymentMethodName["BON_DE_COMMANDE_RECEPTIONNE"] = "BON_DE_COMMANDE_RECEPTIONNE";
    PaymentMethodName["POS_ADYEN"] = "POS_ADYEN";
    PaymentMethodName["STAND_ALONE_ADYEN"] = "STAND_ALONE_ADYEN";
    PaymentMethodName["POS_ADYEN_CREATE_ORDER"] = "POS_ADYEN_CREATE_ORDER";
    PaymentMethodName["POS_ADYEN_PAY_BY_LINK"] = "POS_ADYEN_PAY_BY_LINK";
    PaymentMethodName["KIOSK_ADYEN"] = "KIOSK_ADYEN";
    PaymentMethodName["POS_CARD"] = "POS_CARD";
    PaymentMethodName["POS_CASH"] = "POS_CASH";
    PaymentMethodName["POS_TWINT"] = "POS_TWINT";
    PaymentMethodName["POS_INVOICE"] = "POS_INVOICE";
    PaymentMethodName["POS_BANK_TRANSFER"] = "POS_BANK_TRANSFER";
    PaymentMethodName["POS_INVITATION"] = "POS_INVITATION";
    PaymentMethodName["POS_EXTERNAL"] = "POS_EXTERNAL";
    PaymentMethodName["POS_PROMO_CODE"] = "POS_PROMO_CODE";
    PaymentMethodName["POS_DISCOUNT"] = "POS_DISCOUNT";
    PaymentMethodName["POS_VOUCHER"] = "POS_VOUCHER";
    PaymentMethodName["POS_GIFT_CARD"] = "POS_GIFT_CARD";
    PaymentMethodName["POS_MEMBERSHIP"] = "POS_MEMBERSHIP";
    PaymentMethodName["SPONSORED"] = "SPONSORED";
    PaymentMethodName["TICKET_ONLINE"] = "TICKET_ONLINE";
    PaymentMethodName["TICKET_POS"] = "TICKET_POS";
    PaymentMethodName["PAYMENT_FEE_ONLINE"] = "PAYMENT_FEE_ONLINE";
    PaymentMethodName["TAX"] = "TAX";
    PaymentMethodName["NON_CASH"] = "NON_CASH";
})(PaymentMethodName || (exports.PaymentMethodName = PaymentMethodName = {}));
//# sourceMappingURL=transaction.types.js.map